<template>
    <b-card
    header-bg-variant="primary"
    header-class="py-2 px-3 text-white"
    body-class="p-3"
    footer-class="py-2 px-3"
    class="mx-0">
    <template #header>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#fff" d="M19 2H9c-1.103 0-2 .897-2 2v5.586l-4.707 4.707A1 1 0 0 0 3 16v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2zm-8 18H5v-5.586l3-3 3 3V20zm8 0h-6v-4a.999.999 0 0 0 .707-1.707L9 9.586V4h10v16z"></path><path fill="#A4B0C0" d="M11 6h2v2h-2zm4 0h2v2h-2zm0 4.031h2V12h-2zM15 14h2v2h-2zm-8 1h2v2H7z"></path></svg>
        Property
        <a href="javascript:void(0)" @click="$emit('remove-product-application', product_application.pcom_id)" class="position-absolute cursor-pointer" style="right: -14px; top: -7px;" v-if="is_editable">
            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="20" height="20" viewBox="0 0 512 512">
                <circle fill="#DF3030" cx="256" cy="256" r="256" />
                <g fill="#fff" transform="translate(148, 116) scale(0.55)">
                    <path fill="#fff" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"/>
                </g>
            </svg>
        </a>
    </template>

    <!--Card Body -->
    <h4>{{ product_application.pcom_product_detail.pcp_project_name }}</h4>
    <h5>Unit: {{ product_application.pcom_product_detail.pcp_project_unit_no }}</h5>
    <div class="my-2">
        <p class="text-xs text-muted">Loan Amt.</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_loan_amount | moneyFormatter }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Bank (Interest Rate)</p>
        <p class="font-weight-600">{{ product_application.pcom_bank_code }} ({{ product_application.pcom_product_detail.pcp_interest_rate }}%)</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Monthly Installment</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_monthly_installment }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Tenure</p>
        <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_tenure }} Years</p>
    </div>
    <template #footer>
        <b-row>
            <b-col cols="12" class="d-flex align-items-center justify-content-between cursor-pointer" v-popover:popover>
                <p class="text-primary font-weight-400 d-block d-md-inline-block">More details</p>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#5D79E3" d="M9.4 18 8 16.6l4.6-4.6L8 7.4 9.4 6l6 6-6 6Z"/></svg>
            </b-col>
        </b-row>
        <el-popover
            ref="popover"
            placement="right"
            trigger="click"
        >
            <div class="my-2">
                <p class="text-xs text-muted">S&P</p>
                <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_spa_amount | moneyFormatter }}</p>
            </div>
            <div class="my-2">
                <p class="text-xs text-muted">MOF</p>
                <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_margin_finance }} % </p>
            </div>
            <div class="my-2">
                <p class="text-xs text-muted">Rebate (%)</p>
                <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_rebate_rate }} </p>
            </div>
            <div class="my-2">
                <p class="text-xs text-muted">Rebate (RM)</p>
                <p class="font-weight-600">RM {{ product_application.pcom_product_detail.pcp_rebate_amount | moneyFormatter}} </p>
            </div>
            <div class="my-2">
                <p class="text-xs text-muted">Client Net</p>
                <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_client_net_amount | moneyFormatter }}</p>
            </div>
            <div class="my-2">
                <p class="text-xs text-muted">Cash Back Amt.</p>
                <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_cash_back_amount | moneyFormatter }}</p>
            </div>
            <div class="my-2">
                <p class="text-xs text-muted">Estimate Rental</p>
                <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_project_json.estimate_rental | moneyFormatter }}</p>
            </div>
        </el-popover>
    </template>
</b-card>
</template>
<script>
import { Popover } from 'element-ui'

export default {
    props:['product_application', 'is_editable'],
    components: {
        [Popover.name]: Popover,
    },
    data() {
        return {
            showPopover: false
        }
    },
    methods: {
        onClose() {
            this.showPopover = false
        },
    }
}
</script>